import React                        from 'react';
import PropTypes                    from 'prop-types';
import ItemDescription              from './ItemDescription';
import MiddleBlock                  from './MiddleBlock';
import DailybonusTodayOfferHeadLine from '../../../Dailybonus/DailybonusTodayOffers/DailybonusTodayOfferHeadLine';
import DailyBonusOfferBtn           from '../../../Dailybonus/SubComponents/DailyBonusOfferBtn';
import {isMerchAndHasCode, 
	isCurrencyVoucher}                   from '../../../Dailybonus/dailyBonusHelpers';

const DailybonusTodayItem = props => {
	const hasCode = isMerchAndHasCode(props.bonusOffer.offer, props.bonusOffer.effect);
	const classes = ['dailybonus__mobile--item', 'dailybonus__mobile--item-today'];
	hasCode && classes.push('-has-code');
	const isVoucher = props.bonusOffer.content ? isCurrencyVoucher(props.bonusOffer.content.price) : false; 
	return (
		<div className={classes.join(' ')}>
			<DailybonusTodayOfferHeadLine
				purchased={props.bonusOffer.purchased}
				offer={props.bonusOffer.offer}
				mobile={true}
			/>
			<MiddleBlock {...props.bonusOffer} />
			<ItemDescription bonusOffer={props.bonusOffer} />
			<DailyBonusOfferBtn {...props.bonusOffer} isCurrencyVoucher={isVoucher}/>
		</div>
	);
};

DailybonusTodayItem.propTypes = {
	bonusOffer: PropTypes.shape({
		date:       PropTypes.string,
		offer:      PropTypes.string,
		conditions: PropTypes.array,
		effect:     PropTypes.object,
		quantity:   PropTypes.number,
		content:    PropTypes.object,
		purchased:  PropTypes.bool,
	}),
};

DailybonusTodayItem.defaultProps = {
	bonusOffer: {
		date:       '',
		conditions: [],
		effect:     {},
		quantity:   1,
		content:    null,
		purchased:  false,
	},
};

export default DailybonusTodayItem;